import { cn } from '~shared/utils/cn'
import {
  LeadFormSection,
  LeadFormSectionProps
} from '~widgets/lead-form/components/lead-form-section'

export interface LeadForm1SectionProps
  extends Omit<LeadFormSectionProps, 'title' | 'personImg' | 'decorationImg'> {}

export const LeadForm1Section = ({
  className,
  ...rest
}: LeadForm1SectionProps) => {
  return (
    <LeadFormSection
      title='Получите полную программу курса на личной консультации'
      personImg='/assets/imgs/main-page/lead-section-female.png'
      decorationImg='/assets/imgs/main-page/lead-section-butterfly.png'
      className={cn('container container-slim', className)}
      {...rest}
    />
  )
}

export interface LeadForm2SectionProps extends LeadForm1SectionProps {}

export const LeadForm2Section = ({
  className,
  ...rest
}: LeadForm2SectionProps) => {
  return (
    <LeadFormSection
      title='Остались вопросы? Получите консультацию приемной комиссии'
      personImg='/assets/imgs/main-page/lead-section-male.png'
      decorationImg='/assets/imgs/main-page/lead-section-question.png'
      className={cn('container container-slim', className)}
      {...rest}
    />
  )
}
